import productPageBaseUri from "../../utils/productPageBaseUri";

var init = async function () {
  // find the badge container
  let badgeContainer = document.getElementById("product-badge");
  if (badgeContainer === undefined) return;


  // 2. Get product code from badgeContainer dataset
  const productCode = badgeContainer && badgeContainer.dataset.productId;
  if (!productCode) return;

  const marketing_enrichment_product_badge_api = `${productPageBaseUri}marketing-enrichment-api/product-badge`;

  let badgeData = [];
  try {
    const searchParams = new URLSearchParams();
    searchParams.append('productCodes', productCode);
    const badgeResp = await fetch(`${marketing_enrichment_product_badge_api}?${searchParams.toString()}`, {
      headers: { accept: '*/*' }
    });
    const badgeJson = await badgeResp.json();
    badgeData = badgeJson.content || [];
  } catch (e) {
    badgeData = [];
  }

  // 4. If badge data exists, fetch widget details and render badge
  if (badgeData.length > 0) {
    const badge = badgeData[0];

    if (badge) {
      badge.badgeWidget.forEach(widget => {
          const badgeTitle = widget.badgeTitle;
          if (!badgeTitle) return;

          const badgeEl = document.createElement('div');
          badgeEl.classList.add('badge-container');

          // Prepare CSS variable values
        const badgeTextColor = widget.badgeTextColor;
        const badgeHoverTextColor = widget.badgeHoverTextColor;
        const badgeFocusTextColor = widget.badgeFocusTextColor;
        const badgeBackgroundColor = widget.badgeBackgroundColor;
        const badgeHoverBackgroundColor = widget.badgeHoverBackgroundColor;
        const badgeFocusBackgroundColor = widget.badgeFocusBackgroundColor;
        const badgeBorderColor = widget.badgeBorderColor;
        const badgeHoverBorderColor = widget.badgeHoverBorderColor;
        const badgeFocusBorderColor = widget.badgeFocusBorderColor;

          // Create rg-badge element
          const rgBadge = document.createElement('rg-badge');
          rgBadge.setAttribute('priority', widget.badgeThemeSelection || 'default');
          rgBadge.setAttribute('class', 'hydrated');
          rgBadge.setAttribute('style',
            `--badge-text-color:${badgeTextColor};` +
            `--badge-hover-text-color:${badgeHoverTextColor};` +
            `--badge-focus-text-color:${badgeFocusTextColor};` +
            `--badge-background-color:${badgeBackgroundColor};` +
            `--badge-hover-background-color:${badgeHoverBackgroundColor};` +
            `--badge-focus-background-color:${badgeFocusBackgroundColor};` +
            `--badge-border-color:${badgeBorderColor};` +
            `--badge-hover-border-color:${badgeHoverBorderColor};` +
            `--badge-focus-border-color:${badgeFocusBorderColor};`
          );

          // Build badge content
          const iconHtml = widget.badgeIcon
            ? `<rg-icon icon="${widget.badgeIcon}" margin="right" ratio="1" class="hydrated"></rg-icon>`
            : '';
          const content = `${iconHtml}${badgeTitle}`;
          const inner = widget.badgeLinkUrl
            ? `<a href="${widget.badgeLinkUrl}" target="_blank" title="${widget.badgeLinkDescription || ''}" aria-label="${widget.badgeLinkText || badgeTitle}" style="text-decoration:none;color:inherit;">${content}</a>`
            : content;

          // Set inner HTML
          const span = document.createElement('span');
          span.innerHTML = inner;
          rgBadge.appendChild(span);

          // Add hover event listeners
          rgBadge.addEventListener('mouseenter', function() {
            rgBadge.style.setProperty('--badge-background-color', badgeHoverBackgroundColor);
          });
          rgBadge.addEventListener('mouseleave', function() {
            rgBadge.style.setProperty('--badge-background-color', badgeBackgroundColor);
          });

          badgeEl.appendChild(rgBadge);
          badgeContainer.appendChild(badgeEl);
        });
    }
  }


  // custom badge logic, this is not stored in acoustic content hub.

  try {
    let customOrder = document.getElementById("product-detail-page").getAttribute('data-custom-order');
    if (customOrder) {
      let badgeEl = document.createElement("div");
      badgeEl.classList.add("badge-container");

      badgeEl.innerHTML =
        `<rg-badge priority="default" style="--badge-background-color: #94BAF6;--badge-border-color: #94BAF6;--badge-hover-background-color: #94BAF6;--badge-focus-background-color: #94BAF6;" class="hydrated">
                <span><img style="width: 10px; height: 10px; margin: inherit;" src="/vanity/public/_nuxt/clock.602b7a76.svg"></rg-icon>&nbsp;Made to Order</span>
            </rg-badge>`;
      badgeContainer.appendChild(badgeEl);
    }
  } catch (err) {
    throw new Error(err);
  }

};

export default { init };
